import { render } from "./Buyer'sTerms.vue?vue&type=template&id=facb641c&scoped=true"
import script from "./Buyer'sTerms.vue?vue&type=script&lang=js"
export * from "./Buyer'sTerms.vue?vue&type=script&lang=js"

import "./Buyer'sTerms.vue?vue&type=style&index=0&id=facb641c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-facb641c"]])

export default __exports__